module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-092-min.7b089ab5.jpg";